import localec66dfec0 from '../../lang/nl-NL.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"nl","numberFormats":{"nl":{"currency":{"style":"currency","currency":"EUR","useGrouping":false},"percent":{"style":"percent"},"decimal":{"style":"decimal"},"customFixed":{"maximumFractionDigits":2}}}},
  vueI18nLoader: false,
  locales: [{"code":"nl","iso":"nl-NL","file":"nl-NL.js","name":"NL"}],
  defaultLocale: "nl",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "/app/lang",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {"product/lister/_":{"nl":"/producten/*","en":"/products/*","fr":"/product-liste/*"},"product/detail/_slug":{"en":"/p/:slug?","nl":"/p/:slug?"},"product/lister/actie":{"nl":"/actie","en":"/actie","fr":"/actie"},"brand/index":{"nl":"/merk","en":"/brand","fr":"/marque"},"brand/lister/_":{"nl":"/m/*","en":"/m/*","fr":"/m/*"},"search/_slug":{"nl":"/zoek/:slug?","en":"/search/:slug?","fr":"/chercher/:slug?"},"store/lister/index":{"nl":"/vestigingen","en":"/stores","fr":"/branches"},"store/detail/_slug":{"nl":"/vestigingen/:slug?","en":"/stores/:slug?","fr":"/branches/:slug?"},"blog/tag/_":{"nl":"/tag/*","en":"/tag/*","fr":"/tag/*"},"blog/category/index":{"nl":"/inspiratie","en":"/inspiration","fr":"/actualites"},"blog/category/_":{"nl":"/inspiratie/*","en":"/inspiration/*","fr":"/actualites/*"},"blog/detail/_slug":{"nl":"/inspiratie/post/:slug?","en":"/inspiration/post/:slug?","fr":"/actualites/post/:slug?"},"forgot-password/redirect":{"nl":"/myaccount/resetpassword/redirect","en":"/myaccount/resetpassword/redirect","fr":"/myaccount/resetpassword/redirect"},"forgot-password/index":{"nl":"/wachtwoord-vergeten","en":"/forgot-password","fr":"/oublie-mot-de-passe"},"faq/index":{"en":"/customer-service/faq","nl":"/klantenservice/faq","fr":"/service-clients/faq"},"checkout-thanks/delivery":{"en":"/checkout-thanks","nl":"/checkout-thanks","fr":"/checkout-thanks"},"checkout-thanks/pickup":{"en":"/checkout-thanks-pickup","nl":"/checkout-thanks-pickup","fr":"/checkout-thanks-pickup"}},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"nl","iso":"nl-NL","file":"nl-NL.js","name":"NL"}],
  localeCodes: ["nl"],
  additionalMessages: [],
}

export const localeMessages = {
  'nl-NL.js': () => Promise.resolve(localec66dfec0),
}
